import { router } from '@inertiajs/svelte'

// Reads an optional shared prop (`select_options`, `global_search`, `moderation_pending_count`)
// through a partial reload of whatever page is open. The server answers such a reload without
// running the page's action (AdminSite::SharedPartialReload); the URL, scroll and component
// state stay put. Resolves to the prop's value; rejects when the reload fails.
export const reloadSharedProp = (key, data = {}) =>
  new Promise((resolve, reject) => {
    let settled = false
    router.reload({
      only: [key],
      data,
      preserveUrl: true,
      preserveState: true,
      preserveScroll: true,
      showProgress: false,
      onSuccess: (page) => {
        settled = true
        resolve(page.props[key])
      },
      onFinish: () => {
        if (!settled) reject(new Error(`${key}: reload failed`))
      }
    })
  })

let requestCount = 0

// One page of a server-searched option list (AdminSite::OptionsProp): `{ options, pagy }`.
// Pass `ids` to look up the labels of saved values instead of searching. The `key` echo tells
// this picker's answer from another picker's reload on the same page.
export const loadSelectOptions = async (source, { q = '', page = 1, ids = null, params = {} } = {}) => {
  const key = String((requestCount += 1))
  const filters = Object.fromEntries(Object.entries(params ?? {}).filter(([, value]) => value !== null && value !== undefined && value !== ''))
  const { with_area: withArea, ...rest } = filters
  const request = { source, key, filters: rest }
  if (withArea) request.with_area = withArea
  if (ids != null && String(ids).length > 0) request.ids = Array.isArray(ids) ? ids.join(',') : String(ids)
  else {
    if (q.trim()) request.q = q.trim()
    if (page > 1) request.page = page
  }

  const result = await reloadSharedProp('select_options', { select_options: request })
  if (!result || result.key !== key) throw new Error(`select_options/${source}: no answer`)
  return { options: result.options, pagy: result.pagy }
}
